import React from 'react';
import {Link} from "react-router-dom";
import "./style.css";
//import Vi from "../";

function FaseNav(props) {
  const {ans,meio,prox,conc} = props;
  //console.log(ans,meio,prox)
  const btn_ans = ans && (<>
    {/*<Link to={<Vi id_mundo id_fase={ans[0]} />} title={ans[1].titulo} className="anterior btn">*/}
    <Link name='ans' to={ans.to} className="anterior btn" onClick={ans.onClick}>
        {ans.texto}
    </Link>
    <div className="moldura">
      <div className="interior_anterior">&nbsp;</div>
    </div>
  </>)


  const btn_meio = meio && (
      <Link name='meio' to={meio.to} className="meio  btn" onClick={meio.onClick}>
        {meio.texto}
      </Link>
    )
  //alt=meio[1].titulo


  const btn_prox = prox ? (<>
    <div className="moldura">
      <div className="interior_proxima">&nbsp;</div>
    </div>
    <Link name='prox' className="proxima btn" to={prox.to} onClick={prox.onClick}>
        {prox.texto}
    </Link>
  </>) : undefined

  const btn_conc = conc ? (<>
    <div className="moldura moldura-concluido">
      <div className="interior_proxima">&nbsp;</div>
    </div>
    <Link name='conc' className="concluir btn" to={conc.to} onClick={conc.onClick}>
        {conc.texto}
    </Link>
  </>) : undefined


  return (
    <div className="fase_nav">
      {btn_ans}

      {btn_meio}

      {btn_prox}

      {btn_conc}
    </div>
  )
  /*
  return (
    <div className="fase_nav">
      <div className="anterior">
        <Link to={`./${nFase-1}`} title={nomeA}>&lt; &lt; Voltar</Link>
      </div>
      <div className="moldura">
        <div className="interior_anterior">&nbsp;</div>
      </div>
      <div className="atual"> {nFase} </div>
      <div className="moldura">
        <div className="interior_proxima">&nbsp;</div>
      </div>
      <div className="proxima">
        <Link to={`./${nFase+1}`} title={nomeP}>Avançar &gt; &gt;</Link>
      </div>
    </div>
  )
  */
}

export default FaseNav;
